import { AHIcon, AHText } from "arkh";

export function WorkspaceDifferentOwnerIndicator(props: {
  name: string | null;
}) {
  if (!props.name) return null;
  return (
    <AHText color="text-secondary">
      <AHIcon color="text-secondary" size="xsmall" type="corner-down-right" />{" "}
      {props.name}
    </AHText>
  );
}
